import { Component, OnInit, ViewChild } from '@angular/core';
import { FiltroRelatorioSaldoArmazem } from 'src/app/estoque/armazem/filter/filtro-relatorio-saldo-armazem';
import { PoStorageService } from '@po-ui/ng-storage';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { Produto } from 'src/app/interface/produto';
import { ArmazemLookupService } from 'src/app/service/armazem-lookup-service';
import { Armazem } from 'src/app/interface/armazem';
import { EstoqueService } from 'src/app/estoque/service/estoque.service';
import { ExcelService } from 'src/app/service/excel-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';

@Component({
  selector: 'app-relatorio-saldo-armazem',
  templateUrl: './relatorio-saldo-armazem.component.html',
  styleUrls: ['./relatorio-saldo-armazem.component.css']
})
export class RelatorioSaldoArmazemComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioSaldoArmazem;

  advancedProdutoFilters: Array<PoDynamicFormField>;
  columnsProdutoFilters: Array<PoLookupColumn>;
  fieldFormaterProdutoFilters: ((value: Produto) => string);

  advancedArmazemFilters: Array<PoDynamicFormField>;
  columnsArmazemFilters: Array<PoLookupColumn>;
  fieldFormaterArmazemFilters: ((value: Armazem) => string);

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private poStorageService: PoStorageService,
    private router: Router,
    private estoqueService: EstoqueService,
    private excelService: ExcelService,
    public produtoLookupService: ProdutoLookupService,
    public armazemLookupService: ArmazemLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioSaldoArmazem(this.poStorageService);

    this.advancedProdutoFilters = this.produtoLookupService.getAdvancedFilter();
    this.columnsProdutoFilters = this.produtoLookupService.getColumnsFilter();
    this.fieldFormaterProdutoFilters = this.produtoLookupService.getFieldFormater;

    this.advancedArmazemFilters = this.armazemLookupService.getAdvancedFilter();
    this.columnsArmazemFilters = this.armazemLookupService.getColumnsFilter();
    this.fieldFormaterArmazemFilters = this.armazemLookupService.getFieldFormater;

 }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Saldo de Armazéns' }
    ]
  };


  tabelaPrincipalLoad(): void {
    this.estoqueService.getListaRelatorioSaldoArmazem(this.tabelaPrincipalFiltro.dados).subscribe((ret) => {
      this.tabelaPrincipalItens = ret.items;
    })
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'DB8DATA'    , label: 'Data'         ,width: '8%' , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CB8LOTECTL' , label: 'Lote'         ,width: '8%'},
    {property: 'CB8PRODUTO' , label: 'Produto'      ,width: '10%'},
    {property: 'CB1DESC'    , label: 'Desc Produto' ,width: '22%'},
    {property: 'NB8SALDO'   , label: 'Saldo PC'     ,width: '7%', type: 'number'},
    {property: 'CB8LOCAL'   , label: 'Armazém'      ,width: '8%'},   
    {property: 'NB8QTDORI2' , label: 'Qtd M³'       ,width: '7%', type: 'number'},
    {property: 'Z02PEDIDO'  , label: 'Pedido'       ,width: '15%', type: 'number'},
    {property: 'C5PEDEXP'   , label: 'P.O. number'  ,width: '15%'},
    {property: 'Z02PESO'    , label: 'Peso'         ,width: '15%', type: 'number'},
    {property: 'Z02UR'      , label: 'UR'           ,width: '7%'},
    {property: 'Z02INFORM'  , label: 'Toco/Esqui'   ,width: '10%'},
    {property: 'A1NOME'     , label: 'NomeCliente'  ,width: '15%'},
    {property: 'LOCAL'      , label: 'Portal'       ,width: '15%'},
    {property: 'Z00CODEXP'  , label: 'Romanei EXP'  ,width: '15%'},
    {property: 'Z00DATAEXP' , label: 'DATA_ROMANEI_EXP'  ,width: '25%'},
    {property: 'Z00CODBALD' , label: 'Romanei BALD'  ,width: '15%'},
    {property: 'Z00DATABALD', label: 'DATA_ROMANEI_BALD'  ,width: '25%'},
    
  ];

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'Data'  : String(item.DB8DATA ?? '').split('-').reverse().join('/'),
        'Lote'  : item.CB8LOTECTL,
        'Produto' : item.CB8PRODUTO,
        'Desc Produto'  : item.CB1DESC,
        'Saldo PC'  : item.NB8SALDO,
        'Armazém' : item.CB8LOCAL,
        'Qtd M³'  : item.NB8QTDORI2,
        'Pedido'  : item.Z02PEDIDO,
        'P.O. number'  : item.C5PEDEXP,
        'Peso'  : item.Z02PESO,
        'UR'  : item.Z02UR,
        'Toco/Esqui'  : item.Z02INFORM,
        'Cliente'  : item.C5CLIENTE,
        'NomeCliente'  : item.A1NOME,
        'LOCAL'  : item.LOCAL,
        'Romanei EXP'  : item.Z00CODEXP,
        'DATA_ROMANEI_EXP'  : String(item.Z00DATAEXP ?? '').split('-').reverse().join('/'),
        'Romanei BALD'  : item.Z00CODBALD,
        'DATA_ROMANEI_BALD'  : String(item.Z00DATABALD ?? '').split('-').reverse().join('/')
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Rel Saldo Armazém`);
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }


  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
